import typesData from './typesData'
import getActionInitialData from './getActionInitialData'

const getParsedActionDetail = ({ mode, actionNameType, actionDetail }) => {
  if (mode === 'convert') {
    switch (actionNameType) {
      case 'SUPPORT':
      case 'CANCEL':
        return { ...getActionInitialData(actionNameType), eventType: 'COMMAND' }
      default:
        return { ...getActionInitialData(actionNameType), eventType: actionNameType }
    }
  }

  if (mode === 'revert') {
    if (typesData.clientOperatorActionTypes.includes(actionDetail.actionType)) {
      if (actionDetail.actionSubtype === 'COMMAND') {
        if (actionDetail.actionProperties.intentId === 'SUPPORT') return { eventType: 'SUPPORT' }
        if (actionDetail.actionProperties.intentId === 'CANCEL') return { eventType: 'CANCEL' }
      }

      return { eventType: actionDetail.actionSubtype }
    } else {
      return { eventType: actionDetail.eventType }
    }
  }
}

export default getParsedActionDetail
